/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CouponIdViewCodes200,
  GetApiV1CouponIdViewCodes401,
  GetApiV1CouponIdViewCodes404,
  GetApiV1CouponIdViewCodes500,
  GetApiV1CouponIdViewCodesPathParams,
  GetApiV1CouponIdViewCodesQueryResponse,
} from "../../types/couponCdigosController/GetApiV1CouponIdViewCodes.ts";
import { couponCodeSummaryViewModelSchema } from "../couponCodeSummaryViewModelSchema.ts";

export const getApiV1CouponIdViewCodesPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1CouponIdViewCodesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CouponIdViewCodes200Schema = z.lazy(
  () => couponCodeSummaryViewModelSchema,
) as unknown as ToZod<GetApiV1CouponIdViewCodes200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CouponIdViewCodes401Schema =
  z.any() as unknown as ToZod<GetApiV1CouponIdViewCodes401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CouponIdViewCodes404Schema =
  z.any() as unknown as ToZod<GetApiV1CouponIdViewCodes404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CouponIdViewCodes500Schema =
  z.any() as unknown as ToZod<GetApiV1CouponIdViewCodes500>;

export const getApiV1CouponIdViewCodesQueryResponseSchema = z.lazy(
  () => getApiV1CouponIdViewCodes200Schema,
) as unknown as ToZod<GetApiV1CouponIdViewCodesQueryResponse>;
